import React, { useEffect, useRef, useState } from "react";
import { useAtomValue } from "jotai";
import AppRoutes from "./routes/AppRoutes";
import { authAtom } from "./states/auth";
import { setAuthTokenGetter } from "./services/common";
import { AlertProvider } from "./contexts/AlertContext";
import { SidebarProvider } from "./contexts/SidebarContext";
import { initializeSocket } from "./socket";
import { useAlert } from "./contexts/AlertContext";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import ChatUnreadManager from "./components/ChatUnreadManager";

const SocketHandler = ({ userId }) => {
  const [showModal, setShowModal] = useState(false);
  const [counter, setCounter] = useState(10);
  const { showAlert } = useAlert();
  const location = useLocation();
  const locationRef = useRef(location.pathname); // Mutable ref
  useEffect(() => {
    locationRef.current = location.pathname;
  }, [location]);

  // const location = useLocation();

  useEffect(() => {
    if (userId) {
      const socket = initializeSocket(userId, showAlert, locationRef, {
        onDisconnect: () => {
          setShowModal(true);
          setCounter(10);
        },
        onConnect: () => {
          setShowModal(false);
        },
      });
    }
  }, [userId]);

  // Countdown effect when modal is visible
  useEffect(() => {
    if (!showModal) return;

    let timer;
    if (counter > 1) {
      timer = setTimeout(() => setCounter((prev) => prev - 1), 1000);
    } else if (counter === 1) {
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }

    return () => clearTimeout(timer);
  }, [counter, showModal]);

  return (
    <Modal
      className="info-modal"
      show={!!showModal}
      // onHide={() => setShowModal(null)}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body>
        <div className="text-center">
          <Image src="/images/delete-badge-red.svg" alt="Delete Badge" />
          <h2 className="fs-2 fw-semibold text-gray-700 mt-5 mb-2">
            Oh, ho! disconnected
          </h2>

          <p className="fw-semibold text-gray-700 mt-5 mb-2">
            Please wait... reconnecting in {counter}...
          </p>
          {/* <div className="d-flex align-items-center gap-3">
					  <Button
						variant="primary"
						// onClick={(e) => deleteUserFunction(showModal)}
						className="btn w-100 mt-5"
					  >
						Delete User
					  </Button>
					  <Button
						variant="gray"
						className="btn w-100 mt-5"
						onClick={() => setShowModal(null)}
					  >
						Nope, Cancel
					  </Button>
					</div> */}
        </div>
      </Modal.Body>
    </Modal>
  ); // No UI
};

const App = () => {
  // const { showAlert } = useAlert();
  // const location = useLocation();
  const auth = useAtomValue(authAtom);
  // useEffect(() => {

  // 	// Set the function once to get the latest token
  // 	if(auth?.token && auth?.token.length>0){

  // 		setAuthTokenGetter(() => auth?.token || null);
  // 	}

  //   }, [auth]);
  return (
    <>
      <ChatUnreadManager />
      <AlertProvider>
        <SidebarProvider>
          <SocketHandler userId={auth?.user?.id} />
          <AppRoutes />
        </SidebarProvider>
      </AlertProvider>
    </>
  );
};

export default App;
